import React from "react";
import { Button, Popover, MenuItem, Menu, Position } from "@blueprintjs/core";
import { I18n } from "react-redux-i18n";

const ACTIVE_BOOKINGS = Array.from({ length: 50 }, (_, i) => i + 1)

const MaxActiveBookings = ({ current_value, onValueChange }) => {
    return (
        <Popover
            content={
                <Menu className="prylpoolen-booking-popover">
                    <MenuItem text={I18n.t('new_circle.unlimited')} onClick={() => { onValueChange(-1) }} />
                    {
                        ACTIVE_BOOKINGS.map((max_booking) => {
                            return <MenuItem text={max_booking} onClick={() => { onValueChange(max_booking) }} key={max_booking} />
                        })
                    }
                </Menu>
            }
            position={Position.BOTTOM_LEFT}
        >
            <Button rightIcon="caret-down" className="input-button right select-button">
                {current_value === -1 ? I18n.t('new_circle.unlimited') : current_value}
            </Button>
        </Popover>
    );
}

export default MaxActiveBookings;